export type PaymentOption = 'full' | 'installments';

export interface CompanyPaymentConfig {
  full_settlement_discount_rate: number;
  minimum_down_payment_rate: number;
  maximum_installments: number;
  minimum_installment_amount: number;
}

export interface CompanyThemeConfig {
  color: string;
  logo: string;
}

export interface Company {
  id: string;
  name: string;
  legal_name: string;
  address: string;
  phone: string;
  configs: {
    payment: CompanyPaymentConfig;
    theme: CompanyThemeConfig;
  };
}

export interface Charge {
  id: string;
  description: string;
  identifier: number;
  amount_open: number;
  amount_paid: number;
  amount_realized: number;
  amount_updated: number;
  amount_outstanding: number;
  amount_total: number;
  // Prótese e aparelho complementar são cobrados junto e entram no valor renegociado.
  lab_amount: number;
  amount_negotiable: number;
}

export interface Agreement {
  code: string;
  down_payment_amount: number;
  installments: number;
  installment_amount: number;
  due_day: number;
  charges: Array<number>;
  term?: string;
  signature_providers?: Array<'govbr' | 'd4sign' | 'zapsign'>;
  // A entrada já foi paga? É ela que libera a assinatura do termo.
  paid?: boolean;
}

export interface CustomerSession {
  name: string;
  cpf: string;
  phone: string;
  otp: string;
  customerId?: string;
  agreementCode?: string;
  agreementTotalAmount?: number;
  selectedChargesTotalAmount?: number;
  // Parte do saldo que é prótese/aparelho complementar: não recebe desconto.
  selectedChargesLabAmount?: number;
  selectedCompany?: Company;
  agreement?: Agreement;
  paymentAmount?: number;
  selectedCharges?: Array<number>;
}

const SESSION_KEY = 'deal-session';

export function getSession(): CustomerSession | null {
  if (typeof window === 'undefined') return null;

  const raw = window.sessionStorage.getItem(SESSION_KEY);
  return raw ? (JSON.parse(raw) as CustomerSession) : null;
}

export function saveSession(session: CustomerSession) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearSession() {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(SESSION_KEY);
}

export function formatCurrency(value: number) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
}

export function generateAgreementCode() {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const first = Math.floor(100 + Math.random() * 900);
  const second = Array.from({ length: 3 }, () => letters[Math.floor(Math.random() * letters.length)]).join('');
  return `${first}-${second}`;
}
